module.exports = __webpack_public_path__ + "img/20191214143033799.fe6f6aa1.jpg";